import(/* webpackMode: "eager" */ "/app/assets/images/error-images/NoTeamsFound.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/error-images/overview.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/error-images/table.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/placeholder/player.svg");
;
import(/* webpackMode: "eager" */ "/app/assets/images/placeholder/team.png");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/ads/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/commonNav/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/customLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/myImage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/newsTab/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/series/seriesFixtures/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/series/seriesMatchCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/series/seriesSquads/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/series/standings/standingTable/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/series/stats/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/shared/components/teamSquads/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/widgets/latestNews/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/components/widgets/trendingPlayer/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/shared/google-ads/index.tsx");
